<script setup lang="ts">
import { useState } from '#app'
import { computed } from 'vue'
import type { CmsData, CmsImage } from '~/layers/cms/app/types/cmsTypes'
import { getByPath } from '../../utils/cmsDataHelper'
import placeholder from '~/layers/cms/app/assets/images/placeholder.svg'

const cmsData = useState<CmsData>('cmsData')

if (!cmsData) {
  throw new Error('cmsData not provided')
}

const props = defineProps<{
  cmsDataPath: (string | number)[]
  global?: boolean
}>()

const image = computed(() => getByPath(cmsData.value, props.cmsDataPath)?.component_data as CmsImage)
</script>

<template>
  <NuxtImg
    v-cms-image-element:[image]="{ path: props.cmsDataPath, global: props.global }"
    :src="image?.src ?? placeholder"
    :alt="image?.alt ?? 'Brak obrazu'"
    v-bind="{
      ...(image?.width ? { width: image.width } : {}),
      ...(image?.height ? { height: image.height } : {}),
      ...(image?.format ? { format: image.format } : {}),
      ...(image?.loading ? { loading: image.loading } : {}),
      ...(image?.fit ? { fit: image.fit } : {}),
      ...(image?.quality ? { quality: image.quality } : {})
    }"
  />
</template>
